<template>
    <DCard
        :title="__('messages.dashboard.widgets.one_webshop_orders.title')"
        class="height widget p-3 card"
    >
        <CChartBar
            v-if="oneWebshopOrdersData"
            id="onewebshop-bar"
            type="bar"
            :data="oneWebshopOrdersData"
            :custom-tooltips="false"
            :options="options"
            class="p-3"
            :height="250"
        />
        <span class="help-text">
            {{ '*' + __('messages.dashboard.widgets.one_webshop_orders.help_text') }}
        </span>
    </DCard>
</template>

<script setup>
import { CChartBar } from '@coreui/vue-chartjs'
import { ref, onMounted } from 'vue'
import { route } from '~@/Composables/route'
import { router } from '@inertiajs/vue3'

const oneWebshopOrdersData = ref(null)
const labels = ref({})

onMounted(() => {
    const params = {
        widget: 'one_webshop_orders'
    }
    getOneWebshopOrders(params)
})

const options = ref({
    onHover: (event, chartElement) => {
        event.native.target.style.height = '250px'
        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default'
    },
    onClick: (evt, activeEls, chart) => {
        const status = chart.tooltip.dataPoints[0].dataset.stack
        const _query = {}
        _query.statuses = [status]

        router.get(route('orders.one_webshop.index', {
            _query
        }))
    },
    maintainAspectRatio: false,
    scales: {
        x: {
            grid: {
                display: false
            },
            stacked: true
        },
        y: {
            type: 'logarithmic',
            grid: {
                display: false
            },
            stacked: true,
            ticks: {
                format: { maximumSignificantDigits: 1 }
            }
        }
    },
    plugins: {
        legend: {
            display: true,
            position: 'bottom'
        }
    }
})

function buildDataSet (response) {
    return {
        labels: response.data.labels ? response.data.labels.map(item => item.translation) : [],
        datasets: response.data.orders
    }
}

function getOneWebshopOrders (params) {
    window.axios.get(route('widgets.get-data'), {
        params: params
    })
        .then(function (response) {
            oneWebshopOrdersData.value = buildDataSet(response.data)
            labels.value = response.data.data.labels
        })
}
</script>

<style scoped>
.help-text {
    font-size: 12px;
    font-weight: bold;
    padding: 16px 16px 0px 16px;
}
</style>
